import { render, staticRenderFns } from "./ViewDepartmentContainer.vue?vue&type=template&id=8784fd2a&scoped=true&"
import script from "./ViewDepartmentContainer.vue?vue&type=script&lang=js&"
export * from "./ViewDepartmentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8784fd2a",
  null
  
)

export default component.exports